<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - 7. {{ $t('electricMeter') }}</h3>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('annotations') }}</div>
        <div>
          {{ project.enpalReport.electricMeterNotes }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterAttachment_B') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterAttachment_B"
            :src="project.enpalReport.electricMeterAttachment_B.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterB1State') }}</div>
        <div>
          {{ $t(project.enpalReport.electricMeterB1State) }}
        </div>
        <div>{{ $t('electricMeterB2State') }}</div>
        <div>
          {{ $t(project.enpalReport.electricMeterB2State) }}
        </div>
        <div>{{ $t('electricMeterB3State') }}</div>
        <div>
          {{ $t(project.enpalReport.electricMeterB3State) }}
        </div>
        <div>{{ $t('electricMeterCState') }}</div>
        <div>
          {{ $t(project.enpalReport.electricMeterCState) }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterAttachment_D') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterAttachment_D"
            :src="project.enpalReport.electricMeterAttachment_D.path"
          />
        </div>
        <div>{{ $t('electricMeterAttachment_E') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterAttachment_E"
            :src="project.enpalReport.electricMeterAttachment_E.path"
          />
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
